import { withTranslation } from "next-i18next";
import useFeatures from "@hooks/use-features";
import Badge from "@components/core/Badge";

function CatalogProductStickers({ product, t }) {
  const stickers = useFeatures()?.stickers;

  if (!product?.id || !stickers || stickers.length < 1) return null;

  function displayStickers() {
    return stickers.map((sticker) => {
      if (!product.collections.includes(sticker?.collection_slug)) return null;

      return (
        <Badge variant="light-primary" key={`${product.id}${sticker.collection_slug}`}>
          {t(`catalog:stickers.${sticker.sticker_key}`, sticker.sticker_name)}
        </Badge>
      );
    });
  }

  return (
    <div className="catalog-product-stickers-container">
      {displayStickers()}
    </div>
  );
}

export default withTranslation("catalog")(CatalogProductStickers);
